import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as appSelectors from 'app/state/app/app-selectors';
import { GenericBaseModule } from './module/generic-base-module';
import { paymentMethodType } from 'common/constants';
import { Check } from '../pay-by-check/check';

export function CyberSource(props) {
  const {
    strategyInstance,
    strategies,
    params: { text },
  } = props;
  const location = useLocation();
  const activePaymentMethodTab = useSelector(appSelectors.activePaymentMethodTab);

  const onClick = useCallback(
    (url, data) => {
      const { protocol, host, hostname } = window.location;
      const flowUrl = location.pathname.split('/');
      const flow = flowUrl[flowUrl.length - 2];
      let transformedUrl = data.url;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        transformedUrl = `/${transformedUrl.split('/').slice(2).join('/')}`;
      }
      const paymentUrl = new URL(`${protocol}//${host}${transformedUrl}&flow=${flow}`);
      const place = paymentUrl.searchParams.get('place');

      const context = data.formData.captureContext;
      window[place] = {};
      window[place][data.id] = context;
      window.open(paymentUrl).focus();
      strategyInstance.executeStrategy(strategies, 'postWindowOpen');
    },
    [strategyInstance, strategies, location]
  );

  if (activePaymentMethodTab === paymentMethodType.CHECK) {
    return <Check {...props} />;
  }

  return (
    <GenericBaseModule onClick={onClick} {...props}>
      <div>{text}</div>
    </GenericBaseModule>
  );
}
